import React, { useState } from 'react'
import '../style/selectcategory.css'
const SelectMenuType = ({setMenuType,menuType}) => {
    

    const handleMenuTypeChange = (event) => {
        setMenuType(event.target.value);
    };
  
    return (
        <div className="category-selector">
        <h3>Choose your Menu Type</h3>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              value="veg"
              checked={menuType === 'veg'}
              onChange={handleMenuTypeChange}
            />
            Veg
          </label>
        </div>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              value="nonveg"
              checked={menuType === 'nonveg'}
              onChange={handleMenuTypeChange}
            />
            Non Veg
          </label>
        </div>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              value="omnivores"
              checked={menuType === 'omnivores'}
              onChange={handleMenuTypeChange}
            />
            Both
          </label>
        </div>
      </div>
    );
}

export default SelectMenuType
